import MessageBubble from '@/components/MessageBubble.vue'
import UploadSingleFile from '@/components/UploadSingleFile.vue'
import moment from 'moment'
import jwt_decode from 'jwt-decode'
import queryString from 'query-string'
import { v4 as uuidv4 } from 'uuid'
import { mapGetters } from 'vuex'

export default {
  components: {
    MessageBubble,
    UploadSingleFile
  },
  computed: {
    ...mapGetters(['setting']),

    moment() {
      return moment
    },
    lg() {
      return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl
    },
    quick_replies: {
      get() {
        return this.$store.state.quick_replies
      },
      set(val) {
        this.$store.state.quick_replies = val
      }
    }
  },
  data() {
    return {
      redirecturl:
        'https://tha-adfsqa.mmthqa.com/adfs/oauth2/authorize?response_type=id_token%20token&client_id=7c7f863b-3095-41bf-adf5-62698f77e643&state=TmVzQlMxblBrcF9LVUhHSS5tQ2dQVlZnZGV6cmxIeHFhVWphcTh4Z25xYmlQ&redirect_uri=https://sthqn0001.mmth-intranet-qa.co.th:55500/livechat&scope=openid%20profile%20email%20allatclaims%20role&nonce=TmVzQlMxblBrcF9LVUhHSS5tQ2dQVlZnZGV6cmxIeHFhVWphcTh4Z25xYmlQ',
      input: '',
      userid: '',
      prevHeight: 0,
      showToBottom: false,
      loading: false,
      imgtest:
        'https://cdn3.vectorstock.com/i/1000x1000/46/72/person-gray-photo-placeholder-man-material-design-vector-23804672.jpg',
      messages: [],
      uploadImage: null,
      screenWidth: null
    }
  },
  beforeCreate() {
    if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
      this.$store.state.bgcolor = '#efefef'
    }
  },
  beforeDestroy() {
    this.$store.state.bgcolor = 'white'
  },
  created() {
    var parsed = queryString.parseUrl(this.redirecturl).query

    parsed.nonce = uuidv4().replace(/-/g, '')
    parsed.state = uuidv4().replace(/-/g, '')
    try {
      var token = this.$route.hash ? this.$route.hash.replace('#access_token=') : ''
      var decoded = jwt_decode(token)
      if (decoded.upn) {
        this.userid = decoded.upn
      } else {
        // location.assign(url)
      }
    } catch (err) {
      // location.assign(url)
      // err
    }
  },
  async mounted() {
    document.getElementById('chatbox').addEventListener('scroll', () => {
      var chatboxheight =
        document.getElementById('chatbox').scrollHeight -
        document.getElementById('chatbox').offsetHeight
      var result = chatboxheight - document.getElementById('chatbox').scrollTop
      if (result > 300) {
        this.showToBottom = true
      } else {
        this.showToBottom = false
      }
    })

    let vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    if (this.$store.state.apiKey == 'MITSUBISHIWEBCHAT') {
      this.messages.push({
        actor: 'answer',
        text: 'น้องมิต สวัสดีค่ะ ต้องการสอบถามข้อมูลหรือปัญหาเกี่ยวกับด้านใด สามารถกดปุ่มด้านล่างเพื่อเริ่มสนทนาได้เลยค่ะ',
        buttons: [
          {
            title: 'IT division',
            type: 'postback',
            payload: 'IT division'
          },
          {
            title: 'HR division',
            type: 'postback',
            payload: 'HR division'
          },
          {
            title: 'ICIA division',
            type: 'postback',
            payload: 'ICIA division'
          }
        ],
        type: 'button'
      })
    } else {
      const messages = localStorage.getItem('chatlog') || ''
      if (messages) {
        const chatLogData = JSON.parse(localStorage.getItem('chatlog'))
        const chat = this.showChatLog(chatLogData)
        this.messages = chat

        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
      if (this.$store.state.isJustLogin && this.$store.state.getWelcome) {
        this.$store.state.isJustLogin = false

        this.sendMessage({ title: '{welcome}', payload: '{welcome}', type: 'text' })
      }
    }
  },
  methods: {
    onResizeScreen() {
      const wrapchat = document.getElementsByClassName('wrapchat')
      if (wrapchat && wrapchat.length) {
        this.screenWidth = wrapchat[0].offsetWidth
      }
    },
    showChatLog(message) {
      let messages = []
      if (message.length > 0) {
        message.sort((a, b) => {
          return a.id - b.id
        })
        message.forEach((cl) => {
          if (cl.questiondata) {
            messages.push({
              actor: 'question',
              type: cl.questiontype,
              text: cl.questiondata,
              timestamp: moment(cl.timestamp).format('YYYY-MM-DD HH:mm')
            })
          }

          if (cl.answerby) {
            if (cl.answerby == 'admin') {
              let type = cl.messagetype,
                text = cl.messagedata

              messages.push({
                actor: 'answer',
                type: type,
                text: text,
                timestamp: moment(cl.timestamp).format('YYYY-MM-DD HH:mm')
              })
            }

            if (cl.answerby == 'bot') {
              let messagedata = []
              if (cl.messagedata) {
                messagedata = JSON.parse(cl.messagedata)
                console.log(messagedata)

                messagedata.forEach((el) => {
                  console.log(el)
                  if (el.type == 'text') {
                    messages.push({
                      actor: 'answer',
                      type: el.type,
                      text: el.text,
                      timestamp: moment(cl.timestamp).format('YYYY-MM-DD HH:mm')
                    })
                  }

                  if (el.type == 'button') {
                    messages.push({
                      actor: 'answer',
                      type: el.type,
                      text: el.text,
                      buttons: messagedata[0].buttons,
                      timestamp: moment(cl.timestamp).format('YYYY-MM-DD HH:mm')
                    })
                  }

                  if (el.type == 'image') {
                    messages.push({
                      actor: 'answer',
                      type: el.type,
                      image_url: el.image_url,
                      buttons: messagedata[0].buttons,
                      timestamp: moment(cl.timestamp).format('YYYY-MM-DD HH:mm')
                    })
                  }
                })
              }
            }
          }
        })
      }

      return messages
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)
      element.style.height = this.prevHeight
      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },

    scrollToBottom() {
      var chatbox = document.getElementById('chatbox')
      var offset = chatbox.offsetHeight
      chatbox.scrollTo({
        top: chatbox.scrollHeight - offset,
        left: 0,
        behavior: 'smooth'
      })
    },
    logout() {
      localStorage.setItem('user', '')
      this.$router.push('Login')
    },
    async sendMessage(message) {
      var vm = this
      if (message && message.payload.trim() !== '') {
        const response = await this.pushMessage(
          this.userid || this.$store.state.id || '',
          this.setting.pageid,
          message,
          function (question) {
            if (question && question.text != '{welcome}') {
              vm.messages.push(question)
            }
            vm.input = ''
          }
        )

        if (response) {
          this.quick_replies = response.quick_replies
          response.messages.forEach((el) => {
            this.messages.push({
              actor: 'answer',
              timestamp: moment().format('YYYY-MM-DD HH:mm'),
              ...el
            })
          })
        }
        vm.$nextTick(() => {
          vm.scrollToBottom()
        })
      } else {
        this.input = ''
      }
    },
    handleUploadImage() {},
    onUploadFile(imgUrl) {
      this.sendMessage({ title: 'image', payload: imgUrl, type: 'image' })
      this.uploadImage = null
    }
  }
}
